import { style } from 'typestyle'
export const p12 = style({ padding: '12px' })
